import { getFingerPrint, saveAccessToken } from './auth';
import { authApi } from '../../shared/common/api/endpoints/authApi';

/**
 * Приём человека, который вошёл на сайте.
 *
 * Продающий сайт живёт на scananalytics.ru, кабинет — на lk.scananalytics.ru.
 * Пропуск (access) браузер хранит отдельно для каждого адреса, поэтому сайт
 * не может положить его кабинету напрямую: окно входа на сайте отработало,
 * а кабинет пропуска у себя не увидит и снова попросит пароль.
 *
 * Зато при входе сервер кладёт в куку корешок сессии, и кука выписана на
 * домен кабинета — браузер принимает её и с сайта, потому что домен второго
 * уровня у них общий. Значит кабинету достаточно предъявить этот корешок и
 * получить свежий пропуск уже у себя. Этим здесь и занимаемся.
 *
 * Делаем это только когда сайт явно передал человека — по метке в адресе.
 * Продлевать сессию на каждом заходе нельзя: человек, нажавший «Выйти» с
 * уже истёкшим пропуском, оставляет корешок живым (сервер чистит его только
 * при действующем пропуске) — и такой «умный» кабинет затаскивал бы его
 * обратно, сколько бы он ни выходил.
 */

/** Метка, которую сайт дописывает к адресу кабинета после входа */
export const SITE_HANDOFF_PARAM = 'from';
export const SITE_HANDOFF_VALUE = 'site';

/** Пришёл ли человек с сайта уже вошедшим */
export const hasSiteHandoff = (): boolean => {
  try {
    const params = new URLSearchParams(window.location.search);

    return params.get(SITE_HANDOFF_PARAM) === SITE_HANDOFF_VALUE;
  } catch {
    return false;
  }
};

/** Убираем метку из адреса: своё дело она сделала, в истории ей не место */
export const clearSiteHandoffMark = (): void => {
  try {
    const url = new URL(window.location.href);

    url.searchParams.delete(SITE_HANDOFF_PARAM);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  } catch {
    // адрес разобрать не вышло — метка не мешает, оставляем как есть
  }
};

/**
 * Заканчивает вход, начатый на сайте.
 * @returns true, если пропуск получен и человека можно пускать внутрь
 */
export const finishSiteHandoff = async (): Promise<boolean> => {
  try {
    const fingerprint = await getFingerPrint();
    const response = await authApi.refreshToken(fingerprint);

    if (response.status === 200 && response.data?.access_token) {
      saveAccessToken(response.data.access_token);

      return true;
    }

    return false;

  } catch {
    // Корешка нет, он просрочен или устройство не то — человек просто
    // увидит обычную страницу входа и введёт пароль ещё раз.
    return false;

  } finally {
    clearSiteHandoffMark();
  }
};
